import { render, staticRenderFns } from "./FlightsSearch.vue?vue&type=template&id=09d9b064"
import script from "./FlightsSearch.vue?vue&type=script&lang=js"
export * from "./FlightsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports